import styled from "styled-components";

export const NewPasswordRequiredWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #efefef;
`;